<template>
  <button
    :disabled="isDisabled || isLoading"
    :class="[
      isShadow ? 'shadow' : '',
      isDisabled ? 'opacity-70' : '',
      sizeClass,
      isLoading ? loadingClass : isWarning ? warningClass : defaultClass,
      isLean ? 'h-8' : 'h-10',
      isSmallRadius ? 'rounded-md before:rounded-md' : 'rounded before:rounded',
      classes,
    ]"
    class="font-medium before:content-[''] before:-z-10 before:box-content relative before:absolute before:-inset-2 text-sm lg:text-base"
    @click="click"
    :type="type"
    :id="id"
  >
    <div v-if="!isLoading" class="flex flex-row justify-center gap-2 lg:gap-4">
      <slot></slot>
      <span v-text="text" />
      <slot name="appendIcon"></slot>
    </div>
    <template v-else>
      <div class="flex justify-center text-white">
        <svg
          width="20"
          height="20"
          fill="#fff"
          class="mr-2 animate-spin"
          viewBox="0 0 1792 1792"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"
          ></path>
        </svg>
        &nbsp;
        در انتظار پاسخ
      </div>
    </template>
  </button>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false,
      default: "",
    },
    text: {
      type: String,
      required: false,
      default: "دکمه",
    },
    id: {
      type: String,
      required: false,
    },

    styleType: {
      type: String,
      required: false,
      default: "primary",
      validate: () =>
        "primary" || "secondary" || "tertiary" || "icon" || "shadow",
    },
    size: {
      type: String,
      required: false,
      default: "md",
      validate: () => "sm" || "md" || "2xl" || "full",
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLean: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSmallRadius: {
      type: Boolean,
      required: false,
      default: false,
    },
    isWarning: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShadow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    const click = () => {
      context.emit("clicked");
    };
    const sizeClass = computed(
      () =>
        (props.size === "sm" && "w-28 lg:w-32") ||
        (props.size === "md" && "w-32 lg:w-36") ||
        (props.size === "2xl" && "w-36 lg:w-48") ||
        (props.size === "full" && "w-full")
    );
    const defaultClass = computed(
      () =>
        (props.styleType === "primary" &&
          "bg-blue-500 text-white fill-white  before:active:border-10 before:active:border-primary-300") ||
        (props.styleType === "secondary" &&
          "bg-white text-blue-500 fill-blue-500 border border-blue-500 before:active:border-10 before:active:border-primary-300") ||
        (props.styleType === "tertiary" &&
          "bg-white text-blue-500 underline underline-offset-8 hover:text-primary-600 hover:underline-primary-600") ||
        (props.styleType === "icon" && "bg-transparent") ||
        (props.styleType === "shadow" &&
          "bg-white w-full shadow-xl text-blue-500")
    );
    const disabledClass = computed(
      () =>
        (props.styleType === "primary" &&
          "bg-primary-400 text-white fill-white cursor-not-allowed") ||
        (props.styleType === "secondary" &&
          "bg-white text-primary-400 fill-primary-400 border border-primary-400 cursor-not-allowed") ||
        (props.styleType === "tertiary" &&
          "bg-white text-primary-400 underline underline-offset-8 underline-primary-400 cursor-not-allowed") ||
        (props.styleType === "icon" && "bg-transparent")
    );
    const loadingClass = computed(
      () =>
        (props.styleType === "primary" && "bg-blue-500 cursor-wait") ||
        (props.styleType === "secondary" &&
          "bg-white text-blue-500 border border-blue-500 cursor-wait") ||
        (props.styleType === "tertiary" && "") ||
        (props.styleType === "icon" && "bg-transparent")
    );
    const loadingBarClass = computed(
      () =>
        (props.styleType === "primary" && "text-blue-500 fill-white") ||
        (props.styleType === "secondary" && "text-white fill-blue-500") ||
        (props.styleType === "tertiary" && "text-white") ||
        (props.styleType === "icon" && "bg-transparent")
    );
    const warningClass = computed(
      () =>
        "bg-warning hover:bg-warning before:active:border-10 before:active:border-primary-300"
    );
    return {
      click,
      sizeClass,
      defaultClass,
      disabledClass,
      loadingClass,
      loadingBarClass,
      warningClass,
    };
  },
};
</script>
